import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Tooltip,
  Grid,
  TextField,
  FormControlLabel,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";

import { Modal } from "../Modal";
import { useStyles } from "./CreateFileAndFolder.styles";
import { ErrorMessages } from "../errorMessages";
import { FileInput } from "../../../common/fileinput/fileinput";
import { FolderIcon } from "../../icons";

const initialStateErrorsForm = [];
const noimgurl = "/noimage.png";
const FOLDERACTION = 2;
const FILEACTION = 3;

const BlackCheckbox = withStyles({
  root: {
    color: "black",
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export const CreateFileAndFolder = ({
  isFetching,
  request,
  handleCreateFolder,
  handleCreateFile,
}) => {
  const classes = useStyles();
  const [openFolderDialog, setOpenFolderDialog] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [openDialogFile, setOpenDialogFile] = useState(false);
  const [file, setFile] = useState(null);
  const [clear, setClear] = useState(false);
  const [errorsForm, setErrorsForm] = useState(initialStateErrorsForm);
  const [uploading, setUploading] = useState(false);
  const [isPrivate, setIsPrivate] = useState({ folder: false, file: false });

  useEffect(() => {
    if (request.type === FILEACTION) setUploading(false);
    if (request.type === FILEACTION && !request.isError) {
      setClear(true);
      setFile(null);
      setOpenDialogFile(false);
    } else if (request.type === FOLDERACTION) {
      setOpenFolderDialog(false);
    }
  }, [request]);

  const resetErrors = () => {
    setErrorsForm(initialStateErrorsForm);
  };

  const setError = (key, message) => {
    setErrorsForm((prevState) => {
      return [...prevState, { key, message }];
    });
  };

  /** Create Folder */
  const handleFolderName = (event) => {
    const { value } = event.target;
    setFolderName(value);
  };

  const createFolder = () => {
    resetErrors();

    if (folderName.length) handleCreateFolder(folderName, isPrivate.folder);
    else setError("folderName", "The folder name is required");
  };

  /** Create file */
  const handleImageUpload = (e) => {
    resetErrors();
    setFile(e);
  };

  const createFile = () => {
    setUploading(true);
    if (file !== null) handleCreateFile(file, isPrivate.file);
    else {
      setError("file", "The file input is required");
      setUploading(false);
    }
  };

  const handleChangeChechbox = (event) => {
    const { checked, name } = event.target;
    setIsPrivate({ ...isPrivate, [name]: checked });
  };

  return (
    <>
      <Box className={classes.boxStyle}>
        <Tooltip title="Create Folder">
          <FolderIcon
            onClick={() => {
              setIsPrivate({ folder: false, file: false });
              setFolderName("");
              resetErrors();
              setOpenFolderDialog(true);
            }}
            className={classes.folderIconStyle}
          />
        </Tooltip>
        <Button
          variant="contained"
          color="primary"
          className={[classes.addFilebutton, classes.blueBtn].join(" ")}
          startIcon={<AddIcon className={classes.addIcon} />}
          onClick={() => {
            setIsPrivate({ folder: false, file: false });
            setClear(true);
            setFile(null);
            resetErrors();
            setOpenDialogFile(true);
          }}
        >
          Add file
        </Button>
      </Box>

      <Modal
        actionsDisabled={isFetching}
        title="Create folder"
        open={openFolderDialog}
        confirmButtonText="Create folder"
        cancelButtonText="Cancel"
        onConfirm={() => {
          createFolder();
        }}
        onClose={() => {
          setOpenFolderDialog(false);
        }}
        customCss={[classes.modalStyle, classes.folderModalStyle].join(" ")}
        customCssCancelBtn={classes.cancelBtn}
        customCssConfirmBtn={classes.blueBtn}
        variantCancelBtn="text"
        colorCancelBtn="default"
        actionConfirmDisabled={folderName === ""}
      >
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ErrorMessages errorMessages={errorsForm} onClose={resetErrors} />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="Folder name"
              name="folderName"
              value={folderName}
              onChange={handleFolderName}
              className={classes.textStyle}
            />
          </Grid>
          <Grid item lg={5} md={5} sm={6} xs={8} className={classes.textLeft}>
            <FormControlLabel
              control={
                <BlackCheckbox
                  checked={isPrivate.folder}
                  onChange={handleChangeChechbox}
                  name="folder"
                />
              }
              label="Private"
              className={classes.interTypo}
            />
          </Grid>
        </Grid>
      </Modal>

      <Modal
        actionsDisabled={isFetching}
        title=""
        open={openDialogFile}
        confirmButtonText="Add File"
        cancelButtonText="Cancel"
        actionConfirmDisabled={file === null || errorsForm.length}
        onConfirm={createFile}
        onClose={() => {
          setOpenDialogFile(false);
        }}
        customCss={classes.modalStyle}
        customCssCancelBtn={classes.cancelBtn}
        customCssConfirmBtn={classes.blueBtn}
        variantCancelBtn="text"
        colorCancelBtn="inherit"
      >
        <Grid container>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <ErrorMessages
              disableScrollToTop
              errorMessages={errorsForm}
              onClose={resetErrors}
            />
          </Grid>
          <Grid item xs={12} className={classes.inputStyle}>
            <FileInput
              cssClassName={classes.dragAndDrop}
              height="150px"
              name="file"
              text="Add File"
              value=""
              onHandleChange={(e) => handleImageUpload(e)}
              clear={clear}
              placeholder={noimgurl}
              inputProps={{
                "data-testid": "file",
              }}
              noimg={file || noimgurl}
              maxSize={20000000}
              acceptFile={[
                "image/jpeg",
                "image/gif",
                "image/png",
                "image/svg+xml",
                "text/csv",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/pdf",
                "text/plain",
              ]}
              uploading={uploading}
            />
          </Grid>
          <Grid item xs={12}>
            &nbsp;
          </Grid>
          <Grid item md={5} sm={6} xs={8} className={classes.textLeft}>
            <FormControlLabel
              control={
                <BlackCheckbox
                  checked={isPrivate.file}
                  onChange={handleChangeChechbox}
                  name="file"
                />
              }
              label="Private"
              className={classes.interTypo}
            />
          </Grid>
        </Grid>
      </Modal>
    </>
  );
};

CreateFileAndFolder.propTypes = {
  request: PropTypes.instanceOf(Object).isRequired,
  isFetching: PropTypes.bool.isRequired,
  handleCreateFolder: PropTypes.func,
  handleCreateFile: PropTypes.func,
};
CreateFileAndFolder.defaultProps = {
  handleCreateFolder: (f) => f,
  handleCreateFile: (f) => f,
};
